/* eslint-disable jsx-a11y/label-has-associated-control */
//import { useRef, useState } from 'react';
//import { useTranslation } from 'react-i18next';
//import { useNavigate } from 'react-router-dom';
//import { toast } from 'react-toastify';
//import { getAsync } from '../../../../components/helper/axiosHelper';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Table } from 'semantic-ui-react';
import Userbanner from '../../../../components/elements/Userbanner';
import { getFromLocalStorage } from '../../../../components/helper/authorizationHelper';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import PdfViewerModal from '../../../../components/elements/PdfViewerModal';
import ImageViewModal from '../../../../components/elements/ImageViewModal';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';

const EPUserIdeaSuggestion = () => {
  //const { id } = useParams();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [descEn, setDescEn] = useState('');
  const [inputFile, setinputFile] = useState('');
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [fileBase64URL, setFileBase64URL] = useState('');
  const [selectedImageData, setSelectedImageData] = useState(null);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState(['png', 'jpg', 'jpeg', 'pdf']);
  const [file, setFile] = useState('');
  const { t } = useTranslation();
  const [FileCheck, setFilecheck] = useState('');
  const [inputFileSize, setInputFileSize] = useState('');
  const [epUserID, setEpUserID] = useState(null);
  const [isloading, setIsloading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {pathname} = useLocation();

  const token = localStorage.getItem('token');
  const FileInputRef = useRef();

  const isLogin = () => {
    if (!token && !epUserID) {
      navigate('/donorLogin');
    }
  };
  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const getEPUserData = async () => {
    setIsloading(true);
    await getAsync('EP_UserAuthentication/EPUserByID/', { id: epUserID })
      .then((response) => {
        setIsloading(false);
        if (response != null) {
          const result = response?.data[0];
          setFullName(result?.fullName);
          setMobile(result.mobile);
          setEmail(result.email);
        } else {
          toast.error(`${t('Record Not Found.')}`);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);

    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });

    isLogin();
    if (epUserID !== null) {
      getEPUserData();
      PageHitCountApi(pathname, epUserID);
    }
  }, [epUserID]);

  const bodySubmit = {
    epUserID,
    titleEn,
    descEn,
    fileBase64URL,
    file,
  };

  const validateSubmit = () => {
    let result = true;

    if (titleEn === '' || titleEn === null) {
      result = false;
      toast.warning(t('Please Enter Title.'));
    }
    if (descEn === '' || descEn === null) {
      result = false;
      toast.warning(t('Please Enter Description'));
    }
    if (fileBase64URL === '' || fileBase64URL === null) {
      result = false;
      toast.warning(t('Please Upload File.'));
    }

    return result;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateSubmit()) {
      setIsloading(true);
      await postAsync('EPIdeaService/CreateIEPIdeaService', bodySubmit, axiosConfig, 'multipart/form-data')
        .then((response) => {
          setIsloading(false);
          if (response.data == null) {
            toast.success(t('Registration successful.'));
          } else {
            toast.error(t('Something went wrong, Please try again!'));
          }
        })
        .catch((error) => {
          setIsloading(false);
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const openModal = (e, data) => {
    e.preventDefault();
    if (FileCheck != 'pdf') {
      setGridModalOpen(true);
      setSelectedImageData(data);
    } else {
      setIsOpen(true);
    }
  };
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const closeModal = (e) => {
    e.preventDefault();
    setGridModalOpen(false);
  };

  const getFileUploadBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        // Make a fileInfo Object
        //console.log('Called', reader);
        setFile(reader);
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleFileUpload = (file) => {
    const inputFileFileExtension = file.target.files[0]?.name?.split('.').pop();
    const selectedFile = file.target.files[0];
    const fileSize = selectedFile.size;

    if (
      (inputFileFileExtension == 'jpg' ||
        inputFileFileExtension == 'png' ||
        inputFileFileExtension == 'jpeg' ||
        inputFileFileExtension == 'pdf') &&
      fileSize <= 2097152
    ) {
      setFilecheck(inputFileFileExtension);
      let selectedPhoto = file.target.files[0];

      setinputFile(selectedPhoto.name?.substring(0, 100));
      if (selectedPhoto) {
        const reader = new FileReader();
        reader.onloadend = (resolve) => {
          setInputFileSize(fileSize);
          setFile(resolve.result);
        };
        reader.readAsDataURL(selectedPhoto);
      }

      getFileUploadBase64(selectedPhoto)
        .then((result) => {
          selectedPhoto['base64'] = result;
          setFileBase64URL(result);
          setFile(selectedPhoto);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      FileInputRef.current.value = '';
      setFileBase64URL('');
      setFile('');
      setInputFileSize('');
      toast.error(
        t('Uploaded File must contain these formats [jpg, png, jpeg, pdf] and must not be greater than 2 MBs'),
      );
    }
  };

  const handleFileDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };

  const handleFileDelete = async (e) => {
    e.preventDefault();
    setFile(null);
    setinputFile(null);
    setInputFileSize('');
    FileInputRef.current.value = '';
  };

  return (
    <div className="">
      {isLogin ? (
        <>
          <Userbanner />

          {isloading ? (
            <LoadingAnimation
              imageStyling={''}
              styling={'flex items-center py-5 align-middle justify-center space-x-2'}
            />
          ) : (
            <div className="container-fluid py-5 lg:py-10 ">
              <div className="row justify-center">
                <div className=" col-lg-11">
                  <form>
                    <div className="card">
                      <div className="card-header">
                        <h1 className="font-bold sm:text-2xl text-center text-xl text-customgreen">
                          {' '}
                          {t('Idea Registration')}
                        </h1>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="form-group">
                              <label>{t('Full Name')}</label>
                              <input
                                type="text"
                                value={fullName}
                                disabled
                                style={{
                                  cursor: 'no-drop',
                                  fontWeight: '600',
                                }}
                                className="bg-gray-50  border border-gray-300  text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                              />
                            </div>
                          </div>

                          <div className="col-lg-4">
                            <div className="form-group">
                              <label>{t('Mobile Number')}</label>
                              <input
                                type="text"
                                className="bg-gray-50 text-customgreen border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                                disabled
                                value={mobile}
                                style={{
                                  cursor: 'no-drop',
                                  fontWeight: '600',
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-4">
                            <div className="form-group">
                              <label>{t('Email')}</label>
                              <input
                                type="text"
                                className="bg-gray-50 text-customgreen border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                                disabled
                                value={email}
                                style={{
                                  cursor: 'no-drop',
                                  fontWeight: '600',
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        <br />
                        <Accordion className="rounded-lg">
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Suggestion')}</h2>
                          </AccordionSummary>
                          <AccordionDetails className="rounded-xl">
                            <Typography></Typography>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    {t('Title')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                                    placeholder={t('Enter The Title')}
                                    onChange={(e) => setTitleEn(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    {t('Description')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    style={{ height: '250px' }}
                                    className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full p-2.5"
                                    placeholder={t('Description')}
                                    onChange={(e) => setDescEn(e.target.value)}
                                  />
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>

                        <br />
                        <Accordion px-3>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <h2 className="text-gray-800 p-2 font-bold text-pretty text-md">{t('Documents Upload')}</h2>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <label>
                                    {t('Choose File')}
                                    <span className="errmsg">*</span>
                                  </label>
                                  <input
                                    onChange={handleFileUpload}
                                    type="file"
                                    className=" border border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen block w-full "
                                    accept=".jpg, .png, .jpeg, .pdf"
                                    ref={FileInputRef}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <br />
                                <div className="relative overflow-x-auto  sm:rounded-lg">
                                  {allowedFileExtensions.includes(FileCheck) &&
                                    inputFileSize <= 2097152 &&
                                    inputFileSize != '' && (
                                      <Table className="table text-sm text-center ">
                                        <Table.Header className="text-sm font-bold text-white bg-customgreen uppercase ">
                                          <Table.Row>
                                            <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                            <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                            <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                          </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                          <Table.Row>
                                            <Table.Cell className="text-center align-bottom">1</Table.Cell>
                                            <Table.Cell className="text-center align-bottom">
                                              <label
                                              // style={{
                                              //   color: 'red',
                                              //   fontWeight: '500',
                                              // }}
                                              >
                                                {/* {t(
                                                'Uploaded File must contain these formats [jpg, png, jpeg, pdf]and must not be greater than 2 MBs.',
                                              )}
                                              {inputFileSize} -- {FileCheck} */}
                                                {inputFile}
                                              </label>
                                            </Table.Cell>
                                            <Table.Cell className="text-center align-bottom flex flex-row">
                                              <button
                                                className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                                onClick={(e) => handleFileDownload(e, file)}
                                                style={{
                                                  margin: '0px 5px',
                                                }}
                                              >
                                                <FileDownloadOutlinedIcon />
                                              </button>{' '}
                                              {/* Modal Create */}
                                              <>
                                                <button
                                                  className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                                  onClick={(e) => openModal(e, file)}
                                                  style={{
                                                    margin: '0px 5px',
                                                  }}
                                                >
                                                  <VisibilityOutlinedIcon />
                                                </button>

                                                {FileCheck != 'pdf' ? (
                                                  // <MDBModal
                                                  //   tabIndex="-1"
                                                  //   show={gridModalOpen}
                                                  //   setShow={setGridModalOpen}
                                                  // >
                                                  //   <MDBModalDialog>
                                                  //     <MDBModalContent>
                                                  //       <MDBModalHeader>
                                                  //         <MDBModalTitle>{t('Suggestion')}</MDBModalTitle>
                                                  //         <MDBBtn
                                                  //           type="button"
                                                  //           className="btn-close"
                                                  //           color="none"
                                                  //           onClick={(e) => closeModal(e)}
                                                  //         ></MDBBtn>
                                                  //       </MDBModalHeader>
                                                  //       <MDBModalBody>
                                                  //         <div className="container-fluid bd-example-row">
                                                  //           {fileBase64URL && (
                                                  //             <img
                                                  //               style={{
                                                  //                 height: '250px',
                                                  //                 width: '450px',
                                                  //               }}
                                                  //               src={`${fileBase64URL}`}
                                                  //               alt="img.jpg"
                                                  //             />
                                                  //           )}
                                                  //         </div>
                                                  //       </MDBModalBody>
                                                  //       <MDBModalFooter>
                                                  //         <MDBBtn
                                                  //           color="secondary"
                                                  //           className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen  font-medium rounded-full  text-sm px-5 py-2.5 me-2 mb-2  dark:focus:ring-customgreen"
                                                  //           onClick={closeModal}
                                                  //         >
                                                  //           {t('close')}
                                                  //         </MDBBtn>
                                                  //       </MDBModalFooter>
                                                  //     </MDBModalContent>
                                                  //   </MDBModalDialog>
                                                  // </MDBModal>
                                                  <ImageViewModal
                                                    showModal={gridModalOpen}
                                                    setShowModal={setGridModalOpen}
                                                    closeModal={closeModal}
                                                    title={'Suggestion'}
                                                    renderLink={fileBase64URL}
                                                  />
                                                ) : (
                                                  isOpen && (
                                                    <PdfViewerModal
                                                      pdfBase64={fileBase64URL}
                                                      toggleModal={toggleModal}
                                                      visible={true}
                                                    />
                                                  )
                                                )}
                                              </>
                                              {/* end */}
                                              <button
                                                className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center"
                                                style={{
                                                  margin: '0px 5px',
                                                }}
                                                onClick={(e) => handleFileDelete(e)}
                                              >
                                                <DeleteOutlinedIcon />
                                              </button>
                                            </Table.Cell>
                                          </Table.Row>
                                        </Table.Body>
                                      </Table>
                                    )}
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>

                      <div className="card-footer flex gap-2 justify-center flex-row items-center ">
                        <Link
                          to={'/IdeaSuggUPRegistrationList'}
                          type="submit"
                          onClick={handleSubmit}
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-[38px] py-2 text-center"
                        >
                          {t('Register')}
                        </Link>

                        <Link
                          to={'/IdeaSuggUPRegistrationList'}
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                        >
                          {t('Back')}
                        </Link>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src="https://cdn.dribbble.com/users/761395/screenshots/6287961/error_401.jpg" alt="error401.jpg" />
          </div>
        </>
      )}
    </div>
  );
};

export default EPUserIdeaSuggestion;
